<template>
  <div class="input-group">
    <label>{{ displayName }}</label>
    <input
      type="text"
      v-model="inputValue"
      :placeholder="placeholder"
      :name="name"
    />
  </div>
</template>

<script>
export default {
  name: "input-group",
  props: ["name", "displayName", "placeholder", "value"],
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(inputValue) {
        this.$emit("input", inputValue);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../../styles/colors";

.input-group {
  margin-top: 10px;
  display: flex;
  align-items: center;
  label {
    font-size: 14px;
    text-align: right;
    margin: 0 10px ;
  }
  input {
    flex-grow: 1;
    border: 1px solid $color-border;
    border-radius: 4px;
    padding: 10px;
    width: 50px;
  }
}
</style>
